import { FC, useMemo } from "react"
import { ShopCurrencies } from "@/pages/Shop/values"
import { CARD_SKIN_TYPES } from "@/store/apis/cardBacksAPI"
import { STORE_ITEM_TYPES, useGetStoreQuery } from "@/store/apis/storeAPI"
import { DEFAULT_PAGE_SIZE } from "@/ui/Pagination"
import styles from "../../Shop.module.scss"
import { CardSkinItem } from "../CardSkinItem"
import { ShopCurrencySwitch } from "../ShopCurrencySwitch"

const SKINS_ORDER: readonly CARD_SKIN_TYPES[] = [
  CARD_SKIN_TYPES.ORIGINAL,
  CARD_SKIN_TYPES.GRAY,
  CARD_SKIN_TYPES.DARK,
  CARD_SKIN_TYPES.GREEN,
  CARD_SKIN_TYPES.ANTIQUE,
  CARD_SKIN_TYPES.CYBERPUNK,
  CARD_SKIN_TYPES.SEA,
  CARD_SKIN_TYPES.STEAMPUNK
]

export const SkinsTab: FC = () => {
  const { data: store } = useGetStoreQuery({
    page: 1,
    limit: DEFAULT_PAGE_SIZE,
    type: STORE_ITEM_TYPES.CARD_BACK,
    populate: true
  })

  const sortedItems = useMemo(() => {
    const items = store?.items ?? []
    const byType = new Map(items.map((item) => [item.data?.type, item]))
    const known = new Set<string>(SKINS_ORDER)

    const ordered = SKINS_ORDER.flatMap((type) => {
      const item = byType.get(type)
      return item ? [item] : []
    })
    const rest = items.filter((item) => !known.has(item.data?.type ?? ""))

    return [...ordered, ...rest]
  }, [store?.items])

  return (
    <>
      <ShopCurrencySwitch currencies={ShopCurrencies} />
      <div className={styles.Shop_content_body_list}>
        {sortedItems.map((item) => (
          <CardSkinItem {...item} key={item._id} />
        ))}
      </div>
    </>
  )
}
